import SiteLayout from "@/components/feature/SiteLayout";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import StoriesExplorer from "@/pages/stories/components/StoriesExplorer";
import { useSeo } from "@/hooks/useSeo";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { stories } from "@/mocks/stories";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "爆料库 - 黑暗爆料",
    url: "https://heianbaoliao.example.com/stories",
    description: "按栏目聚合的匿名爆料与知情人揭底稿件列表。",
    inLanguage: "zh-CN",
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "爆料稿件列表",
    numberOfItems: stories.length,
    itemListElement: stories.slice(0, 10).map((story, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: story.title,
      url: `https://heianbaoliao.example.com/story/${story.id}`,
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://heianbaoliao.example.com/" },
      { "@type": "ListItem", position: 2, name: "爆料库", item: "https://heianbaoliao.example.com/stories" },
    ],
  },
];

export default function StoriesPage() {
  useSeo({
    title: "爆料库 - 匿名爆料与线人曝料列表｜黑暗爆料",
    description:
      "黑暗爆料库按商业暗账、行业黑幕、职场内幕、灰色地带等栏目聚合全部匿名爆料稿件，支持按栏目筛选与关键词搜索，每篇均标注信源类型与核实程度。",
    keywords: "黑暗爆料列表,匿名爆料,线人曝料,知情人揭底,行业黑幕,职场内幕",
    path: "/stories",
    jsonLd,
  });

  useScrollReveal([]);

  return (
    <SiteLayout>
      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-content px-4 py-8 md:px-6 md:py-10">
          <Breadcrumbs items={[{ name: "爆料库" }]} />
          <div className="mt-5 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <h1 className="font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
                爆料库
              </h1>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
                这里收录了由知情人、线人与内部从业者投递并整理的全部稿件。每一篇都标注了信源代号、区域范围与核实程度，涉及个人与机构的信息均已脱敏。
              </p>
            </div>
            <p className="flex shrink-0 items-center gap-2 rounded-lg border border-background-300 bg-background-50 px-4 py-3 text-sm font-label text-foreground-700">
              <i className="ri-file-list-3-line text-lg text-primary-600" aria-hidden="true"></i>
              当前共 <span className="font-heading text-lg font-bold text-foreground-950">{stories.length}</span> 篇公开稿件
            </p>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-content px-4 py-10 md:px-6 md:py-12">
        <StoriesExplorer />
      </div>
    </SiteLayout>
  );
}